/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/authContext";
import ENDPOINTS from "../../services/endPoints";
import usePost from "../../hooks/usePost";
import QUERY_KEYS from "../../services/queryKeys";
import { ClipLoader } from "react-spinners";
import {
  loginInitialValues,
  loginValidationSchema,
} from "../../utils/validations/login";
import useDelete from "../../hooks/useDelete";
import axios from "axios";

const DeleteReason = [
  "App is buggy or slow",
  "Content isn't relevant for me",
  "Too many notifications",
  "I didn't mean to join",
  "Only interested in free content",
  "Other",
];

const DeleteAccount = () => {
  const { logout } = useContext(AuthContext);
  const [passwordHide, setPasswordHide] = useState(true);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const handlePassword = () => setPasswordHide(!passwordHide);
  const [user, setUser] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  // Hooks for login and delete API
  const { mutateAsync: loginMutateAsync, isLoading: isLoggingIn } = usePost(
    ENDPOINTS.USER_LOGIN,
    QUERY_KEYS.USER_LOGIN_QUERY_KEY
  );
  // Login first, then open modal
  const {
    errors,
    handleChange,
    handleBlur,
    values,
    touched,
    resetForm,
    handleSubmit,
  } = useFormik({
    initialValues: loginInitialValues,
    validationSchema: loginValidationSchema,
    onSubmit: async (values) => {
      const data = {
        email: values.email,
        password: values.password,
        type: "1",
        device_id: "12345ABCDE",
        device_type: "web",
        fcm_key: "dummy_fcm_key",
      };
      try {
        const response = await loginMutateAsync(data);
        if (response.status === true) {
          toast.success("Login successful. Please confirm reason to delete.");
          setShowReasonModal(true); // open modal after login
          setUser(response.data); // store user data including token
        } else {
          toast.error(response.message || "Login failed.");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.errors?.[0]?.message ||
            error?.response?.data?.message ||
            "Login failed. Please try again."
        );
      }
    },
  });
  console.log("User token:", user?.token); // Debug log

  // Final deletion
  const handleConfirmDelete = async () => {
    if (!selectedReason) {
      toast.error("Please select a reason before proceeding.");
      return;
    }

    if (!user?.token) {
      toast.error("User token not found. Please log in again.");
      return;
    }

    setIsDeleting(true);
    console.log("Deleting account with token:", user.token);

    try {
      const response = await axios.delete(
        process.env.REACT_APP_BASE_URL + ENDPOINTS.DELETE_USER,
        {
          data: {
            feedback: [selectedReason], // ✅ Send reason as array
            type: "user",
            device_id: "123456789",
            device_type: "web",
            fcm_key: "dummy_fcm_key",
          },
          headers: {
            Authorization: `Bearer ${user.token}`, // ✅ Token from current state
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.status === true) {
        toast.success("Your account has been deleted.");
        logout();
        setShowReasonModal(false);
        resetForm();
        setUser(null);
      } else {
        toast.error(response.data?.message || "Unable to delete account.");
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Account deletion failed. Please try again."
      );
    } finally {
      setIsDeleting(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") handleSubmit(event);
  };

  return (
    <div>
      <main className="main-content mt-0">
        <section>
          <div className="page-header min-vh-100">
            <div className="container">
              <div className="row">
                <div className="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                  <div className="card card-plain">
                    <div className="card-header pb-0 text-start">
                      <h4 className="main-heading" style={{ color: "#f90000" }}>
                        Delete Account
                      </h4>
                      <p className="mb-0 text-muted">
                        Please confirm your email and password to proceed with
                        account deletion. <br />
                        <strong>This action cannot be undone.</strong>
                      </p>
                    </div>

                    <div className="card-body">
                      <form>
                        <div className="mb-3">
                          <label>Email</label>
                          <input
                            type="email"
                            className="form-control form-control-lg"
                            placeholder="Enter your email"
                            name="email"
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                          />
                        </div>
                        {touched.email && errors.email && (
                          <p className="error">{errors.email}</p>
                        )}

                        <div className="mb-3 position-relative">
                          <label>Password</label>
                          <input
                            type={passwordHide ? "password" : "text"}
                            className="form-control form-control-lg"
                            placeholder="Enter your password"
                            name="password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onKeyDown={handleKeyDown}
                          />
                          <div
                            className="position-absolute top-50 end-3"
                            onClick={handlePassword}
                            style={{ cursor: "pointer" }}
                          >
                            {passwordHide ? (
                              <img
                                src="../assets/logos/visibility_off.svg"
                                alt="Hide"
                                width="17px"
                              />
                            ) : (
                              <img
                                src="../assets/logos/visibility_on.svg"
                                alt="Show"
                                width="17px"
                              />
                            )}
                          </div>
                        </div>
                        {touched.password && errors.password && (
                          <p className="error">{errors.password}</p>
                        )}

                        <div className="text-center">
                          <button
                            type="button"
                            className="btn btn-lg w-100 mt-3 mb-0 text-white fw-bold"
                            style={{
                              backgroundColor: "#f90000",
                              borderColor: "#f90000",
                            }}
                            onClick={() => handleSubmit()}
                            disabled={isLoggingIn}
                          >
                            {isLoggingIn ? (
                              <ClipLoader color="#fff" size={15} />
                            ) : (
                              "Continue"
                            )}
                          </button>

                          <p
                            className="mt-2 text-muted"
                            style={{ fontSize: "14px" }}
                          >
                            Once deleted, all your data will be permanently
                            removed.
                          </p>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {/* Right Panel */}
                <div className="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                  <div className="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden">
                    <img
                      className="login_logo_img"
                      src="./assets/logos/main-logo.svg"
                      alt=""
                    />
                    <h5 className="text-white mt-4">
                      Goodbye, we’ll miss you!
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Reason Modal */}
      {showReasonModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content p-3">
              <div className="modal-header border-0">
                <h5 className="modal-title text-danger">Delete Account</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowReasonModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <p>Please tell us why you want to delete your account:</p>
                <div className="list-group">
                  {DeleteReason.map((reason, idx) => (
                    <label
                      key={idx}
                      className="list-group-item d-flex align-items-center"
                      style={{ cursor: "pointer" }}
                    >
                      <input
                        type="radio"
                        name="deleteReason"
                        value={reason}
                        checked={selectedReason === reason}
                        onChange={(e) => setSelectedReason(e.target.value)}
                        className="form-check-input me-2"
                        style={{ accentColor: "#dc3545", borderColor: "black" }} // red accent color
                      />
                      {reason}
                    </label>
                  ))}
                </div>
              </div>

              <div className="modal-footer border-0 d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowReasonModal(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                  disabled={isDeleting}
                >
                  {isDeleting ? (
                    <ClipLoader color="#fff" size={15} />
                  ) : (
                    "Confirm Delete"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccount;
